import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import TabStripViewModelType from '@/ViewModels/Controls/TabStripViewModel';
import TabStripTabType from '@/Controls/TabStripTab';
import Utilities from '@/Utility/Utilities';

export default class TabStrip extends Control {

    private TabStripTab = ComponentManager.getControl<typeof TabStripTabType>('TabStripTab');
    private jQueryControl: JQuery;
    private elements: Array<TabStripTabType>;

    /**
     * @override
     */
    public widget: KnockoutObservable<kendo.ui.TabStrip>;

    public constructor(private viewModel: TabStripViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div><ul></ul></div>');

        this.applyBindings(this.jQueryControl.find('ul'), {
            kendoTabStrip: {
                animation: this.viewModel.animation,

                widget: this.widget
            }
        });

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: kendo.ui.TabStrip): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'tabstrip',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            invalid: this.viewModel.invalidationText,

            visible: this.viewModel.isVisible,

            styles: this.definePureComputed({
                read: () => {
                    var styles = [];

                    if (this.viewModel.isWizard === true) {
                        styles.push('wizard');
                    } else {
                        styles.push('default');
                    }

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    var states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    return states;
                }
            })
        });

        if (this.viewModel.tabs.length > 0) {
            this.elements = [];

            for (var i = 0; i < this.viewModel.tabs.length; i++) {
                widget.append({ text: '', content: ' ', encoded: false });
                this.viewModel.tabs[i].content = $(widget.contentElement(i)) as JQuery;

                var tabStripTab = new this.TabStripTab(this.viewModel.tabs[i], this.jQueryControl.find('li').last());
                var tuple = tabStripTab.getTuple();

                this.elements.push(tabStripTab);
            }

            widget.activateTab(widget.tabGroup.find('li:eq(' + this.viewModel.selectedIndex() + ')'));
            this.viewModel.tabs[this.viewModel.selectedIndex()].isActive(true);
        }

        this.defineSubscription(this.viewModel.selectedIndex, (selectedIndex: number) => {
            widget.activateTab(widget.tabGroup.find('li:eq(' + selectedIndex + ')'));
            this.viewModel.tabs.forEach((t) => {
                if (t.isActive())
                    t.isActive(false);
            });
            this.viewModel.tabs[selectedIndex].isActive(true);
        });
        
        widget.bind('activate', (event) => {
            let selectedIndex = $(event.item).index();
            this.viewModel.selectedIndex(selectedIndex);
        });
    }
}

ComponentManager.setControl('TabStrip', TabStrip, 'RADPresentation.HTMLClient.DefaultViewExtensions');